<div class="detail-container">
  <form name="documentForm" #assetForm="ngForm">
    <div class="section container-fluid col-md-11 justify-content-center" fxLayoutGap="grid">
      <div class="innertitletxt">
        Référence :
        <span *ngIf="!isCreateMode"> modification</span>
        <span *ngIf="isCreateMode"> création</span>
      </div>
      <div class="card">
        <div class="card-body">
          <div fxLayout="column" fxFlex="100" fxLayoutAlign="start">
            <div fxLayout="row" fxFlex="100" fxLayoutGap="10px">
              <div fxFlex="40" fxFlex.gt-sm="40">
                <mat-form-field floatLabel="always" appearance="outline">
                  <mat-label>Référence * </mat-label>
                  <input matInput [(ngModel)]="asset.Reference" name="Reference" type="text" [disabled]="!isCreateMode">
                </mat-form-field>
              </div>
              <div fxFlex="40" fxFlex.gt-sm="40" class="dropDownStyle">
                <mat-form-field floatLabel="always" appearance="outline">
                  <mat-label>Type * </mat-label>
                  <input matInput hidden readonly>
                  <ng-multiselect-dropdown placeholder="Sélectionner..." (onSelect)="onSelectAssetType($event,'select')" (onDeSelect)="onSelectAssetType($event,'deselect')" [disabled]="!isCreateMode"
                    [settings]="assetTypesDropDownSettings" name="selectedItemsAssetTypes" [data]="assetTypes" [(ngModel)]="selectedItemsAssetTypes" required>
                  </ng-multiselect-dropdown>
                </mat-form-field>
              </div>
              <div fxFlex="20" fxFlex.gt-sm="20">
                <mat-form-field floatLabel="always" appearance="outline">
                  <mat-label>Actif</mat-label>
                  <input matInput readonly hidden>
                  <mat-slide-toggle [(ngModel)]="asset.IsActive" name="IsActive" [disabled]="((asset.Id && asset.IsActive && !asset.CanBeDisabled) || (!asset.IsActive && !asset.OperationalGroupId ))"
                    tooltip="Activer/Désactiver la référence" class="customToggle">
                  </mat-slide-toggle>
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row" fxFlex="100" fxLayoutGap="10px">
              <div fxFlex="40" fxFlex.gt-sm="40" class="dropDownStyle">
                <mat-form-field floatLabel="always" appearance="outline">
                  <mat-label>Groupe opérationnel </mat-label>
                  <input matInput hidden readonly>
                  <ng-multiselect-dropdown placeholder="Sélectionner..." (onSelect)="onSelectOperationalGroup($event,'select')" (onDeSelect)="onSelectOperationalGroup($event,'deselect')"
                    (onFilterChange)="onGroupFilterChange(2, $event)" [settings]="operationalGroupsDropDownSettings" name="selectedItemsOperationalGroups" [data]="operationalGroups"
                    [(ngModel)]="selectedItemsOperationalGroups">
                  </ng-multiselect-dropdown>
                </mat-form-field>
              </div>
              <div fxFlex="40" fxFlex.gt-sm="40" class="dropDownStyle">
                <mat-form-field floatLabel="always" appearance="outline">
                  <mat-label>Société destinataire <span *ngIf="IsRecipientEntityMandatory"> * </span> </mat-label>
                  <input matInput hidden readonly>
                  <ng-multiselect-dropdown placeholder="Sélectionner..." (onSelect)="onSelectRecipientEntitiy($event,'select')" (onDeSelect)="onSelectRecipientEntitiy($event,'deselect')"
                    [settings]="recipientEntitiesGroupsDropDownSettings" name="selectedItemsRecipientEntities" [data]="recipientEntities" [(ngModel)]="selectedItemsRecipientEntities"
                    [required]="IsRecipientEntityMandatory">
                  </ng-multiselect-dropdown>
                </mat-form-field>
              </div>
              <div fxFlex="20" fxFlex.gt-sm="20"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div fxLayout=”row” fxLayoutAlign="end" class="bottom-bar">
      <div fxLayout=”row” fxLayoutAlign="end">
        <div class="btnSpacerCol">
          <button mat-stroked-button class="currentBtn" matTooltip="Annuler" (click)="onCancel()">
            <mat-icon>cancel</mat-icon>
            <span class="long-btn-span" fxHide fxShow.gt-md>Annuler</span>
          </button>
        </div>
        <div class="btnSpacerCol">
          <button mat-stroked-button class="currentBtnColor" matTooltip="Enregistrer" (click)="onSave()" [disabled]="!IsFormValid">
            <mat-icon>save</mat-icon>
            <span class="long-btn-span" fxHide fxShow.gt-md>Enregistrer</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
